import { makeStyles } from '@material-ui/core/styles'
import { customTheme } from '../../styles/customTheme'

export const validacaoExecucaoCicloStyles = makeStyles(() => ({
  Container: {
    padding: '24px',
    backgroundColor: customTheme.colors.white01,
    borderRadius: '8px',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
    margin: '16px'
  },
  TituloContainer: {
    marginBottom: '24px',
    borderBottom: `2px solid ${customTheme.colors.primary}`,
    paddingBottom: '16px'
  }
}))
